import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
function dataRenderUser(data){
    return data.map(item => ({
        user_account_id: item.user_account_id,
        user_family: item.user_family,
        user_image_type:item.user_image_type,
        user_image_url:item.user_image_url,
        user_name:item.user_name,
        user_phone:item.user_phone
    }))
}
function dataRenderProduct(data){
    return data.map(item => ({
        id: item.id,
        category: Array.isArray(item.category)
        ? item.category.map(f => ({
            id: f.id,
            title: f.title
        })):[],
        address:item.address,
        address_lat:item.address_lat,
        address_lon:item.address_lon,
        call:item.call,
        chat:item.chat,
        city:item.city,
        count:item.count,
        created_at:item.created_at,
        cut_count:item.cut_count,
        deleted_at:item.deleted_at,
        description:item.description,
        do_type:item.do_type,
        filter:item.filter,
        like:item.like,
        media:Array.isArray(item.media)
        ? item.media.map(f => ({
            id: f.id,
            url: f.url,
            type: f.type
        })):[],
        price:item.price,
        self:item.self,
        status:item.status,
        title:item.title,
        updated_at:item.updated_at,
        user_account_id:item.user_account_id,
        user_family:item.user_family,
        user_image_type:item.user_image_type,
        user_image_url:item.user_image_url,
        user_name:item.user_name,
        user_phone:item.user_phone,
    }))
}
function dataRenderList(data){
    return data.map(item => ({
        id: item.id,
        user_reaction_id: item.user_reaction_id,
        parent_id: item.parent_id,
        type:item.type,
        text:item.text,
        create_at:item.create_at,
        updated_at:item.updated_at,
        deleted_at:item.deleted_at,
        request_user_account_id:item.request_user_account_id,
        response_user_account_id:item.response_user_account_id,
        self:item.self
    }))
}
export const useChatStore = defineStore('chat', {
    state: () => ({
        cardsUser: [],
        notFound: false,
        hasMoreUser: false,
        isLoadedUser: false,
        userSelectedId: 0,
        cardsProduct: [],
        hasMoreProduct: false,
        isLoadedProduct: false,
        productSelectedId: 0,
        userReactionId:0,
        cardsList: [],
        hasMoreList: false,
        isLoadedList: false,
        chatInfo: null
    }),
    actions: {
        async fetchChatUsers(limit = 10, offset = 0, append = false) {
            try{
                const res = await sendApi({
                    action: 'get_product_chat',
                    control: 'product',
                    data: { limit:limit,offset:offset,action:'user' },
                })
                if (res.status === 'success') {
                    const newproducts = dataRenderUser(res.data);
                    const filteredproducts = newproducts.filter(user => user.user_account_id)
                    if(append) {
                        this.cardsUser = [...this.cardsUser, ...filteredproducts]
                    }
                    this.isLoadedUser = true
                    this.hasMoreUser = res.has_more ?? false
                    return filteredproducts
                }
                return []
            } catch (err) {
                console.log(err);
            }
        },
        async fetchChatProduct(limit = 10, offset = 0, append = false) {
            try{
                const res = await sendApi({
                    action: 'get_product_chat',
                    control: 'product',
                    data: { limit:limit,offset:offset,action:'product'},
                })
                if (res.status === 'success') {
                    const newproducts = dataRenderProduct(res.data);
                    const filteredproducts = newproducts.filter(product => product.id)
                    if(append){
                        this.cardsProduct = [...this.cardsProduct, ...filteredproducts]
                    }
                    this.isLoadedProduct = true
                    this.hasMoreProduct = res.has_more ?? false
                    return filteredproducts
                }
                return []
            } catch (err) {
                console.log(err);
            }
        },
        async fetchChatList(limit = 10, offset = 0, append = false) {
            try{
                const res = await sendApi({
                    action: 'get_product_chat',
                    control: 'product',
                    data: { limit:limit,offset:offset,action:'list',selectProductId:this.productSelectedId,selectUserId:this.userSelectedId },
                })
                if (res.status === 'success') {
                    const newproducts = dataRenderList(res.data);
                    this.userReactionId = newproducts[0]?.user_reaction_id
                    const filteredproducts = newproducts.filter(list => list.id)
                    if(append){
                        this.cardsList = [...this.cardsList, ...filteredproducts]
                    }
                    this.isLoadedList = true
                    this.hasMoreList = res.has_more ?? false
                    this.notFound=false
                    return filteredproducts
                } else {
                    this.notFound=true
                    return []
                }
            } catch (err) {
                console.log(err);
            }
        },
        setUserSelected(id){
            if(parseInt(id)>0){
                this.userSelectedId = parseInt(id)
            }
        },
        setProductSelected(id){
            if(parseInt(id)>0){
                this.productSelectedId = parseInt(id)
            }
        },
        async sendMessage(text,edit){
            try{
                const res = await sendApi({
                    action: 'add_product_chat',
                    control: 'product',
                    data: { text:text,userReactionId:this.userReactionId,selectProductId:this.productSelectedId,selectUserId:this.userSelectedId,edit:edit??{} },
                })
                return res.status === 'success';
            }catch(e){
                console.error(e);
                return false
            }
        },
        async deleteChat(id){
            try{
                const res = await sendApi({
                    action: 'delete_product_chat',
                    control: 'product',
                    data: { deleteChatId:id },
                })
                return res.status === 'success';
            }catch(e){
                console.error(e);
                return false
            }
        },
        resetList(){
            this.userSelectedId= 0
            this.productSelectedId = 0
            this.cardsList=[]
            this.isLoadedList = false
        },
        async getChatInfo(){
            try{
                const res = await sendApi({
                    action: 'info_product_chat',
                    control: 'product',
                    data: { selectProductId:this.productSelectedId,selectUserId:this.userSelectedId },
                })
                if (res.status === 'success') {
                    this.notFound=false
                    this.chatInfo = res.data
                }else{
                    this.notFound=true
                    this.chatInfo = null
                }
            }catch(e){
                console.error(e)
                this.notFound=true
                this.chatInfo = null
            }
        },
        resetChatInfo(){
            this.chatInfo = null            
        }
    }
})